export const getSplitFAQs = (faqs: any) => {
  const firstHalfFAQs = faqs.filter(
    (item: any, index: number) => index < faqs.length / 2
  );
  const secondHalfFAQs = faqs.filter(
    (item: any, index: number) => index >= faqs.length / 2
  );
  return { firstHalfFAQs, secondHalfFAQs };
};
